// extracted by mini-css-extract-plugin
module.exports = {"scroll":"Scroll_scroll__37eLQ"};